import { all, takeEvery, takeLatest, put, fork } from "redux-saga/effects";
import constants from "./CONSTANTS";
import actions from "src/store/auth/actions";
import profileActions from "src/store/profileMain/actions";
import mainAxios from "src/settings/axios";
import { toast } from "react-toastify";
import { formatByIdSaga } from "../helpers/formatByIdSaga";
import {
  biometricLoginSign,
  biometricSetup,
  getCredentialIdsForUser,
  getDeviceGuidForUser,
} from "src/hooks/utils/biometricUtilities";
const AUTH_URL = "/services/rcp/profile/auth/";

export function* loginRequest() {
  yield takeLatest(constants.LOGIN_REQ, function* (action) {
    yield put(actions.loading(true));

    try {
      const { data } = yield mainAxios.post(AUTH_URL + "login", {
        personalNumber: action.pId,
        password: action.password,
      });

      if (data?.success) {
        localStorage?.setItem("act", data.data.accessToken);
        localStorage?.setItem("rft", data.data.refreshToken);
        localStorage?.setItem("alm", data.data.autoLogoutMinute);

        if (action.rememberMe) {
          localStorage?.setItem("usr", action.pId);
          localStorage?.setItem("pwd", btoa(action.password));
        } else {
          if (
            localStorage?.getItem("usr")?.length <= 0 &&
            localStorage?.getItem("usr")
          ) {
            localStorage?.removeItem("usr");
            localStorage?.removeItem("pwd");
          }
        }

        yield put(actions.loginSuccess({ UserName: action.pId }));
        yield put(
          actions.userMustChangePassword(data.data.userMustChangePassword)
        );
        yield put(actions.loading(false));
      }
    } catch (e) {
      yield put(actions.setLoginRequest(e?.response.data.ExceptionCode));
      console.log(e);
      yield put(actions.loading(false));
    }
  });
}

export const USER_PASS_INCORRECT = "USER_PASS_INCORRECT";
export function* ChangeUserPassword() {
  yield takeLatest(constants.CHANGE_USER_PASSWORD, function* (action) {
    try {
      yield put(actions.loading(true));

      const { data } = yield mainAxios.patch(
        "/services/capp/admin/mu/ChangeUserPassword",
        {
          OldPassword: action.oldPassword,
          NewPassword: action.newPassword,
        }
      );

      if (data?.success) {
        const message = yield formatByIdSaga("notifications.passwordChanged");
        toast.success(message);
        yield put(actions.loading(false));
        yield put(actions.userMustChangePassword(false));
      }
    } catch (e) {
      if (e.response.data.ExceptionCode === USER_PASS_INCORRECT) {
        const message = yield formatByIdSaga(
          "notifications.passwordCouldntChange"
        );
        toast.error(message);
      } else {
        const messageError = yield formatByIdSaga(
          "notifications.passwordIsWrong"
        );
        toast.error(messageError);
      }
      yield put(actions.loading(false));
      console.log(e);
    }
  });
}

export function* logoutRequest() {
  yield takeEvery(constants.LOGOUT_USER, function* (action) {
    try {
      localStorage.removeItem("act");
      localStorage.removeItem("rft");
      localStorage.removeItem("alm");

      toast.dismiss(); // remove all toasts

      // yield put(actions.resetAll());
    } catch (e) {
      console.log(e);
    }
  });
}

export function* GetApprovalsExpirationStatus() {
  yield takeLatest(
    constants.GET_APPROVAL_EXPIRATION_STATUS,
    function* (action) {
      try {
        yield put(actions.loading(true));

        const { data } = yield mainAxios.get(
          "/services/ccp/appr/GetApprovalsExpirationStatus"
        );

        if (data?.success) {
          yield put(actions.setApprovalsExpirationStatus(data.data));
          yield put(actions.loading(false));
        }
      } catch (e) {
        yield put(actions.loading(false));
        console.log(e);
      }
    }
  );
}
export function* getRegisterUser() {
  yield takeLatest(constants.GET_MAIN_REGISTER_USER, function* (action) {
    yield put(actions.loading(true));
    try {
      let errorStatus = "";
      const { data } = yield mainAxios
        .post(AUTH_URL + "registeruser", {
          personalNumber: action.payload?.pId,
          acceptedTerms: true,
          otp: action.payload?.otp,
        })
        .then((x) => x?.data)
        .catch(function (error) {
          if (error.response) {
            // The request was made and the server responded with a status code      // that falls out of the range of 2xx      console.log(error.response.data);
            if (
              error.response?.status === 504 ||
              error.response?.status === 500
            ) {
              errorStatus = "notifications.couldntRegister";
            } else {
              errorStatus = "notifications.couldntFindActivePolicy";
            }
          } else if (error.request) {
            // The request was made but no response was received      // `error.request` is an instance of XMLHttpRequest in the browser       // and an instance of http.ClientRequest in node.js      console.log(error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
          }
        });
      if (errorStatus !== "") {
        const message = yield formatByIdSaga(errorStatus);
        toast.error(message);
      }
      if (!data?.success && data?.success !== undefined) {
        // eslint-disable-next-line no-throw-literal
        throw {
          errorCode: data.errorCode,
          errorMessage: data.errorMessage,
        };
      }
      yield put(
        actions.getLoginwithcode({
          personalNumber: action.payload?.pId,
          otp: action.payload?.otp,
        })
      );
      // yield put(actions.loginSuccess({ UserName: action.payload?.pId }));
      yield put(actions.loading(false));
      //toast.success("რეგისტრაცია წარმატებით განხორციელდა");
    } catch (e) {
      // let message;
      if (!e?.response.data?.success) {
        // if (
        //   e?.response.data?.status === 504 ||
        //   e?.response.data?.status === 500
        // ) {
        //   message = yield formatByIdSaga("notifications.couldntRegister");
        // } else {
        // message = yield formatByIdSaga("notifications.couldntFindActivePolicy");
        // }
        // toast.error(message);
      }
      console.log(e);
      yield put(actions.loading(false));
    }
  });
}

export function* getLoginwithcode() {
  yield takeLatest(constants.GET_MAIN_LOGIN_WITH_CODE, function* (action) {
    yield put(actions.loading(true));

    try {
      const { data } = yield mainAxios.post(
        AUTH_URL + "loginwithcode",
        action.payload
      );

      if (data?.success) {
        localStorage.setItem("act", data.data.accessToken);
        localStorage.setItem("rft", data.data.refreshToken);
        localStorage.setItem("alm", data.data.autoLogoutMinute);

        yield put(
          actions.loginSuccess({ UserName: action?.payload?.personalNumber })
        );
        yield put(
          actions.userMustChangePassword(data.data.userMustChangePassword)
        );
        yield put(actions.loading(false));
      }
    } catch (e) {
      console.log(e);

      if (!e?.response.data?.success) {
        const message = yield formatByIdSaga(
          "notifications.verificationCodeIsWrong"
        );
        toast.error(message);
      }
      yield put(actions.loading(false));
    }
  });
}

export function* getLoginSendOTP() {
  yield takeLatest(constants.GET_MAIN_LOGIN_SEND_OTP, function* (action) {
    try {
      yield put(actions.setLoginSendOTP(undefined));
      yield put(actions.loading(true));
      const { data } = yield mainAxios.post(AUTH_URL + "sendotp", {
        personalNumber: action.payload,
      });
      yield put(actions.loading(false));
      yield put(actions.setLoginSendOTP(data?.success));
    } catch (e) {
      yield put(actions.loading(true));
      yield put(actions.setLoginSendOTP(false));
      console.error(e);
    }
  });
}

export function* getValidateotp() {
  yield takeLatest(constants.GET_MAIN_VALIDATE_OTP, function* (action) {
    try {
      yield put(actions.loading(true));
      const { data } = yield mainAxios.post(
        AUTH_URL + "validateotp",
        action.payload
      );

      yield put(actions.loading(false));
      yield put(actions.setValidateotp(data?.success));
    } catch (e) {
      yield put(actions.loading(false));
      const message = yield formatByIdSaga(
        "notifications.verificationCodeIsWrong"
      );

      if (!e?.response.data?.success) {
        toast.error(message);
      }

      // toast.error(e?.response.data.ExceptionMessage);
      yield put(actions.setValidateotp(false));
      console.error(e);
    }
  });
}

export function* getRecoverpassword() {
  yield takeLatest(constants.GET_MAIN_RECOVER_PASSWORD, function* (action) {
    try {
      yield put(actions.loading(true));
      const { data } = yield mainAxios.post(
        AUTH_URL + "recoverpassword",
        action.payload
      );
      localStorage?.setItem("pwd", "");

      yield put(actions.setRecoverpassword({ success: data?.success }));
      const message = yield formatByIdSaga("notifications.passwordChanged");
      toast.success(message);
      yield put(actions.loading(false));
    } catch (e) {
      yield put(
        actions.setRecoverpassword({
          success: false,
          exceptionCode: e?.response?.data?.ExceptionCode || null,
        })
      );

      if (e?.response.data.status === 400) {
        const errors = e?.response?.data?.errors?.NewPassword;
        console.log(errors);
        yield put(
          actions.setRecoverpassword({
            success: false,
            exceptionCode: e?.response?.data?.errors?.NewPassword || null,
          })
        );
      } else {
        yield put(
          actions.setRecoverpassword({
            success: false,
            exceptionCode: e?.response?.data?.ExceptionCode || null,
          })
        );
      }
      if (e?.response.data.ExceptionCode === "404") {
        const message = yield formatByIdSaga("notifications.sesssionExpired");
        toast.error(message);
      }
      yield put(actions.loading(false));
      // console.error(e);
    } finally {
      yield put(profileActions.setServiceCenterUpdateCounter());
    }
  });
}

export function* getCheckUser() {
  yield takeLatest(constants.GET_MAIN_CHECK_USER, function* (action) {
    try {
      yield put(actions.loading(true));
      yield put(actions.setCheckuser({}));
      const { data } = yield mainAxios.get(
        AUTH_URL + "checkuser?personalNumber=" + action.payload
      );
      yield put(actions.loading(false));
      yield put(actions.setCheckuser(data?.data));

      if (!data?.data?.isClient) {
        const message = yield formatByIdSaga(
          "notifications.couldntFindActivePolicy"
        );
        toast.error(message);
      }
    } catch (e) {
      yield put(actions.loading(false));
      yield put(actions.setCheckuser({}));

      console.error(e);
    }
  });
}

//////////////// identomat
export function* getStartidentomat() {
  yield takeLatest(constants.GET_MAIN_START_IDENTOMAT, function* (action) {
    try {
      yield put(actions.setStartidentomat(false));

      const { data } = yield mainAxios.post(
        AUTH_URL + "startidentomat",
        action.payload
      );

      yield put(actions.setStartidentomat(data?.data));
    } catch (e) {
      const message = yield formatByIdSaga(
        "notifications.wrongInsuranceNumber"
      );

      if (e?.response?.data?.ExceptionCode === "417") {
        toast.error(message);
      }
      console.error(e);
      yield put(actions.setStartidentomat(undefined));
    }
  });
}

export function* getValidateidentomat() {
  yield takeLatest(constants.GET_MAIN_VALIDATE_IDENTOMAT, function* (action) {
    try {
      yield put(actions.setValidateidentomat(false));

      const { data } = yield mainAxios.get(
        AUTH_URL + "validateidentomat?sessionId=" + action.payload
      );

      yield put(actions.setValidateidentomat(data?.data));
    } catch (e) {
      toast.error(e.response.data?.ExceptionMessage);
      console.error(e);
      yield put(actions.setValidateidentomat(undefined));
    }
  });
}
export function* getValidateInsurer() {
  yield takeLatest(constants.GET_VALIDATE_INSURER, function* (action) {
    try {
      yield put(actions.setValidateInsurer(false));
      const body = action.payload;
      const url = AUTH_URL + "validateinsurer";
      const { data } = yield mainAxios.post(url, body);

      yield put(actions.setValidateInsurer(data?.success));
    } catch (e) {
      const message = yield formatByIdSaga(
        "notifications.wrongInsuranceNumber"
      );
      if (e?.response?.data?.ExceptionCode === "417") {
        toast.error(message);
      } else {
        toast.error(e.response.data?.ExceptionMessage);
      }

      console.error(e);
      yield put(actions.setValidateInsurer(undefined));
    }
  });
}

export function* getSendotptomobile() {
  yield takeLatest(constants.GET_MAIN_SNED_OTP_TO_MOBILE, function* (action) {
    try {
      yield put(actions.setSendotptomobile(false));

      const { data } = yield mainAxios.post(AUTH_URL + "sendotptomobile", {
        mobileNumber: action.payload,
      });

      yield put(actions.setSendotptomobile(data?.success));
    } catch (e) {
      toast.error(e.response.data?.ExceptionMessage);
      console.error(e);
      yield put(actions.setSendotptomobile(undefined));
    }
  });
}

export function* getChangemobile() {
  yield takeLatest(constants.GET_MAIN_CHANGE_MOBILE, function* (action) {
    try {
      yield put(actions.setChangemobile(false));

      const { data } = yield mainAxios.post(
        AUTH_URL + "changemobile",
        action.payload
      );

      const message = yield formatByIdSaga(
        "notifications.phoneChangedSuccessfully"
      );
      if (data?.success) toast.success(message);

      yield put(actions.setChangemobile(data?.success));
    } catch (e) {
      toast.error(e.response.data?.ExceptionMessage);
      console.error(e);
      yield put(actions.setChangemobile(undefined));
    }
  });
}
export function* getBiometricLoginStatus() {
  yield takeLatest(constants.GET_BIOMETRIC_LOGIN_STATUS, function* (action) {
    try {
      yield put(actions.setBiometricLoginStatus({ success: undefined }));
      const { userName } = action.payload;
      const credentialIds = yield getCredentialIdsForUser(userName);

      if (!credentialIds) throw { errorMessage: "No credentials" };
      const credentialId = credentialIds;
      const { data } = yield mainAxios
        .post(AUTH_URL + "BiometricLogin/Status", { userName, credentialId })
        .then((x) => x);

      if (
        !data?.success &&
        data?.success !== undefined
        // ||
        // displayableErrorTypes?.[errorId] === undefined
      ) {
        // eslint-disable-next-line no-throw-literal
        throw {
          errorCode: data.errorCode,
          errorMessage: data.errorMessage,
        };
      }

      yield put(
        actions.setBiometricLoginStatus({
          success: data?.success,
          data: data?.data,
        })
      );
    } catch (e) {
      yield put(actions.setBiometricLoginStatus({ success: false }));
    }
  });
}

export function* getBiometricSetup() {
  yield takeLatest(constants.GET_BIOMETRIC_SETUP, function* (action) {
    try {
      yield put(actions.setBiometricSetup({ success: undefined }));

      const { username } = action.payload;

      const { publicKeyPem, credentialId } = yield biometricSetup(username);

      const { data } = yield mainAxios
        .post(AUTH_URL + "BiometricLogin/Setup", {
          publicKeyPem,
          credentialId,
        })
        .then((x) => x);

      if (!data?.success) throw { errorMessage: data.errorMessage };

      yield put(actions.setBiometricSetup({ success: true, credentialId }));
    } catch (e) {
      yield put(actions.setBiometricSetup({ success: false }));
    }
  });
}

export function* getBiometricLogin() {
  yield takeLatest(constants.GET_BIOMETRIC_LOGIN, function* (action) {
    try {
      yield put(actions.setBiometricLogin({ success: undefined }));

      const { userName } = action.payload;
      const credentialIds = yield getCredentialIdsForUser(userName);
      if (!credentialIds) throw { errorMessage: "No credentials" };
      const credentialId = credentialIds;

      const { data: startData } = yield mainAxios
        .post(AUTH_URL + "BiometricLogin/Start", { userName, credentialId })
        .then((x) => x);

      if (!startData?.success || !startData?.data?.payload)
        throw { errorMessage: "Missing payload" };

      const signature = yield biometricLoginSign(
        credentialId,
        startData.data.payload
      );
      console.log(signature);
      const { data: loginData } = yield mainAxios
        .post(AUTH_URL + "v2/BiometricLogin", {
          userName,
          credentialId,
          payload: startData.data.payload,
          signature,
        })
        .then((x) => x);

      if (!loginData?.success) throw { errorMessage: loginData.errorMessage };

      yield put(
        actions.setBiometricLogin({ success: true, data: loginData.data })
      );
      if (loginData?.success) {
        localStorage?.setItem("act", loginData.data.accessToken);
        localStorage?.setItem("rft", loginData.data.refreshToken);
        localStorage?.setItem("alm", loginData.data.autoLogoutMinute);

        yield put(actions.loginSuccess({ UserName: userName }));
        yield put(
          actions.userMustChangePassword(loginData.data.userMustChangePassword)
        );
        yield put(actions.loading(false));
      }
    } catch (e) {
      yield put(actions.setBiometricLogin({ success: false }));
    }
  });
}
export function* getShowBiometricsModal() {
  yield takeLatest(constants.GET_SHOW_BIOMETRICS_MODAL, function* (action) {
    try {
      yield put(actions.setShowBiometricsModal(false));

      const deviceGuid = yield getDeviceGuidForUser(action.payload);

      const { data } = yield mainAxios
        .get(`${AUTH_URL}BiometricLogin/Popup?credentialId=${deviceGuid}`)
        .then((x) => x);

      if (!data?.success) throw { errorMessage: data.errorMessage };

      yield put(actions.setShowBiometricsModal(data?.data));
    } catch (e) {
      yield put(actions.setShowBiometricsModal(false));
    }
  });
}
export function* getDisableBiometricsPopUp() {
  yield takeLatest(constants.GET_DISABLE_BIOMETRIC_POP_UP, function* (action) {
    try {
      const deviceGuid = yield getDeviceGuidForUser(action.payload);
      const { data } = yield mainAxios
        .post(`${AUTH_URL}BiometricLogin/DisablePopup`, {
          credentialId: deviceGuid,
        })
        .then((x) => x);

      if (!data?.success) throw { errorMessage: data.errorMessage };
    } catch (e) {}
  });
}
// Exporting all sagas as 1 root saga
export default function* rootSaga() {
  yield all([
    fork(loginRequest),
    fork(logoutRequest),
    fork(ChangeUserPassword),
    fork(GetApprovalsExpirationStatus),
    fork(getLoginSendOTP),
    fork(getCheckUser),
    fork(getRegisterUser),
    fork(getLoginwithcode),
    fork(getValidateInsurer),
    fork(getValidateotp),
    fork(getRecoverpassword),
    fork(getStartidentomat),
    fork(getValidateidentomat),
    fork(getSendotptomobile),
    fork(getChangemobile),
    fork(getBiometricLoginStatus),
    fork(getBiometricSetup),
    fork(getBiometricLogin),
    fork(getShowBiometricsModal),
    fork(getDisableBiometricsPopUp),
  ]);
}
